export const defaultRegionOfInterestDistance = 40;

export class RegionOfInterestState {
  enabled = false;
  useForAllCameras = true;
  distanceForAlCameras = defaultRegionOfInterestDistance;
  distancePerCamera: StrictRecord<string, number> = {};
}
